import {TotalMealsApp} from "../Functionality/TotalMealsApp";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import TotalMealsTable from "./TotalMealsTable";
import TotalMealsCards from "./TotalMealsCards";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @param {Function} props.handleBtnDinning - Callback to switch to dining view.
 * @param {Function} props.handleBtnSettings - Callback to switch to settings view.
 * @param {Function} props.handleBtnDepartmentPolicies - Callback to switch to department policies view.
 * @param {Function} props.handleBtnTotalMeals - Callback to switch to total meals view.
 *
 */
const TotalMeals = (props) => {
    const {
        subViewChild,
        setCriteria,
        finalArray,
        setFinalArray,
        searchElement,
        criteria,
        selectedOption,
        setBodyForExport,
        subView,
        setSubViewChild,
        handleBtnDinning,
        handleBtnSettings,
        handleBtnDepartmentPolicies,
        handleBtnTotalMeals,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        setSelectedOption,
        setRender,
        option,
        modified,
        setModified
    } = props;

    const {
        selectedDate,
        setSelectedDate
    } = TotalMealsApp({
        subViewChild,
        setCriteria,
        setFinalArray,
        setSearchElement
    })

    return (
        <>
            {/* Conditional rendering: List view */}
            { subViewChild === VIEW_TYPE.LIST.name &&
                <TotalMealsTable
                    searchElement={searchElement}
                    criteria={criteria}
                    finalArray={finalArray}
                    selectedOption={selectedOption}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    subView={subView}
                    subViewChild={subViewChild}
                    setSubViewChild={setSubViewChild}
                    handleBtnDinning={handleBtnDinning}
                    handleBtnSettings={handleBtnSettings}
                    handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                    handleBtnTotalMeals={handleBtnTotalMeals}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    setSelectedOption={setSelectedOption}
                    setRender={setRender}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    modified={modified}
                    setModified={setModified}
                />
            }

            {/* Conditional rendering: Grid view */}
            { subViewChild === VIEW_TYPE.GRID.name &&
                <TotalMealsCards
                    subView={subView}
                    subViewChild={subViewChild}
                    setSubViewChild={setSubViewChild}
                    handleBtnDinning={handleBtnDinning}
                    handleBtnSettings={handleBtnSettings}
                    handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                    handleBtnTotalMeals={handleBtnTotalMeals}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    option={option}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    setRender={setRender}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    finalArray={finalArray}
                />
            }
        </>
    )
}

export default TotalMeals
